import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";

import ReactGA from "react-ga";

import CheckWebP from "../Common/CheckWebP";

import DecorImage from "../Media/decor.png";
import GGCImage from "../Media/ggc.jpg";
import FamilyGemsImage from "../Media/familyGems.png";
import EventsBWImage from "../Media/eventsBW.png";
import DetourImage from "../Media/detour.jpg";

import DecorImageWebP from "../Media/decor.webp";
import GGCImageWebP from "../Media/ggc.webp";
import FamilyGemsImageWebP from "../Media/familyGems.webp";
import EventsBWImageWebP from "../Media/eventsBW.webp";
import DetourImageWebP from "../Media/detour.webp";

const styles = theme => ({
	card: {
		maxWidth: "100%",
		backgroundColor: theme.palette.primary.main,
		[theme.breakpoints.down("xs")]: {
			paddingBottom: 80
		}
	},
	media: {
		height: "auto"
	},
	listButton: {
		padding: 2,
		textTransform: "none",
		fontWeight: 400,
		letterSpacing: "0.00938em",
		lineHeight: 1.5,
		fontSize: "1rem",
		textAlign: "left"
	},
	decorUp: {
		marginBottom: "-5px"
	},
	textBox: {
		backgroundColor: theme.palette.white,
		margin: 20,
		padding: 20,
		borderRadius: 20,
		display: "inline-block"
	},
	cardHeader: {
		backgroundColor: theme.palette.white70
	},
	adImage: {
		height: 150,
		width: 150,
		borderRadius: 150
	},
	adText: {
		color: theme.palette.white,
		textDecoration: "none"
	},
	adContainer: {
		padding: 10,
		alignItems: "center",
		textAlign: "center"
	},
	supporters: {
		textAlign: "center",
		justifyContent: "center",
		padding: 20
	},
	arrText: {
		padding: 20,
		color: theme.palette.white
	}
});

class SupportersCard extends React.Component {
	constructor() {
		super();
		this.state = {
			CheckWebP: CheckWebP()
		};
	}

	render = () => {
		const { classes } = this.props;
		const { CheckWebP } = this.state;

		return (
			<React.Fragment>
				<Card className={classes.card}>
					<img
						src={CheckWebP ? DecorImageWebP : DecorImage}
						alt={"decorImage"}
					/>
					<CardHeader
						title={<i> Partners, supporters and media</i>}
						className={classes.cardHeader}
					/>
					<Grid container className={classes.supporters}>
						<Grid item className={classes.adContainer}>
							<ReactGA.OutboundLink
								eventLabel="toGabsGolfClub"
								to="https://www.facebook.com/GaboroneGolfClub/"
								target="_blank"
								rel="noopener noreferrer"
								className={classes.adText}
							>
								<img
									src={CheckWebP ? GGCImageWebP : GGCImage}
									alt={"GGC"}
									className={classes.adImage}
								/>
							</ReactGA.OutboundLink>
							<Typography variant={"h6"} className={classes.adText}>
								Gaborone Golf Club
							</Typography>
							<small className={classes.adText}>Event host</small>
						</Grid>
						<Grid item className={classes.adContainer}>
							<ReactGA.OutboundLink
								eventLabel="toDetour"
								to="https://www.facebook.com/Detour-661020560950378/"
								target="_blank"
								rel="noopener noreferrer"
								className={classes.adText}
							>
								<img
									src={CheckWebP ? DetourImageWebP : DetourImage}
									alt={"Detour"}
									className={classes.adImage}
								/>
							</ReactGA.OutboundLink>

							<Typography variant={"h6"} className={classes.adText}>
								Detour
							</Typography>
							<small className={classes.adText}>Photographer</small>
						</Grid>
						<Grid item className={classes.adContainer}>
							<ReactGA.OutboundLink
								eventLabel="toFamilyGems"
								to="https://familygems.co.bw/2019/02/09/what-is-the-ggc-5k-run-and-is-it-really-free/?fbclid=IwAR1734FMv5ZAagYvuvNEIiul7vxffRPRNeVFw8fSNBZhM3rflkSEqrZv5mQ"
								target="_blank"
								rel="noopener noreferrer"
								className={classes.adText}
							>
								<img
									src={CheckWebP ? FamilyGemsImageWebP : FamilyGemsImage}
									alt={"familyGems"}
									className={classes.adImage}
								/>
							</ReactGA.OutboundLink>

							<Typography variant={"h6"} className={classes.adText}>
								Family Gems
							</Typography>
						</Grid>
						<Grid item className={classes.adContainer}>
							<ReactGA.OutboundLink
								eventLabel="toEventsBW"
								to="https://events.co.bw"
								target="_blank"
								rel="noopener noreferrer"
								className={classes.adText}
							>
								<img
									src={CheckWebP ? EventsBWImageWebP : EventsBWImage}
									alt={"Events"}
									className={classes.adImage}
								/>
							</ReactGA.OutboundLink>

							<Typography variant={"h6"} className={classes.adText}>
								Events Botswana
							</Typography>
						</Grid>
					</Grid>
					<hr />
					<Typography variant={"subtitle1"} className={classes.arrText}>
						© 2019 GGC5k - All Rights Reserved. Created by
						<ReactGA.OutboundLink
							eventLabel="toMantzor"
							to="https://mantzor.com"
							target="_blank"
							rel="noopener noreferrer"
							className={classes.adText}
						>
							{" "}
							mantzor.com{" "}
						</ReactGA.OutboundLink>
						&
						<ReactGA.OutboundLink
							eventLabel="toTerHaar"
							to="http://www.dsterhaar.com/"
							target="_blank"
							rel="noopener noreferrer"
							className={classes.adText}
						>
							{" "}
							DS ter Haar Advisory.{" "}
						</ReactGA.OutboundLink>
					</Typography>
				</Card>
			</React.Fragment>
		);
	};
}

SupportersCard.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SupportersCard);
